import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        function disableElement(element) {
            element.setAttribute('disabled', 'disabled');
        }

        function enableElement(element) {
            element.removeAttribute('disabled');
        }

        function requireElement(element) {
            element.setAttribute('required', 'required');
        }

        function unrequireElement(element) {
            element.removeAttribute('required');
        }

        function hideElement(element) {
            element.setAttribute('hidden', 'hidden');
        }

        function appearElement(element) {
            element.removeAttribute('hidden');
        }

        // English presentation checkbox logic
        const isEnglishCheckbox = document.getElementById('presentation_presentation_attributes_is_english');
        if (isEnglishCheckbox != null) {
            isEnglishCheckbox.addEventListener('click', function () {
                if (this.checked) {
                    disableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    unrequireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    hideElement(document.getElementById('title-ja'));
                    disableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
                } else {
                    enableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    requireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    appearElement(document.getElementById('title-ja'));
                    enableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
                }
            });
            if (isEnglishCheckbox.checked) {
                disableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                unrequireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                hideElement(document.getElementById('title-ja'));
                disableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
            }
        }

        function setIndex(index, element) {
            ['name', 'id'].forEach(attribute => {
                if (element.getAttribute(attribute) === null) {
                    return;
                }
                const value = element.getAttribute(attribute).replace(/\d+/, index);
                element.setAttribute(attribute, value);
            })
        }

        // Re-assign field indexes so they follow the order of the items on screen.
        // updateItem(item, index) updates the order number and labels of each item.
        function renumberItems(container, itemSelector, updateItem) {
            const items = container.querySelectorAll(itemSelector);
            items.forEach((item, i) => {
                const index = i + 1;
                item.querySelectorAll('input, select').forEach((element) => setIndex(index, element));
                item.querySelectorAll('.sortable-handle').forEach((element) => {
                    if (items.length > 1) {
                        appearElement(element);
                    } else {
                        hideElement(element);
                    }
                });
                item.setAttribute('data-index', index);
                updateItem(item, index);
            });
        }

        // Reorder the items in the container by dragging their .sortable-handle, then call onReorder
        function makeSortable(container, itemSelector, onReorder) {
            let draggedItem = null;

            // Only make the item draggable while the handle is held, so text in the inputs can still be selected
            container.addEventListener('mousedown', (event) => {
                const handle = event.target.closest('.sortable-handle');
                if (handle != null) {
                    handle.closest(itemSelector)?.setAttribute('draggable', 'true');
                }
            });
            container.addEventListener('mouseup', (event) => {
                event.target.closest(itemSelector)?.removeAttribute('draggable');
            });
            container.addEventListener('dragstart', (event) => {
                const item = event.target.closest(itemSelector + '[draggable]');
                if (item == null) {
                    return;
                }
                draggedItem = item;
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', item.dataset.index);
                item.classList.add('opacity-50');
            });
            container.addEventListener('dragover', (event) => {
                if (draggedItem == null) {
                    return;
                }
                event.preventDefault();
                const item = event.target.closest(itemSelector);
                if (item == null || item === draggedItem) {
                    return;
                }
                const rect = item.getBoundingClientRect();
                const after = event.clientY > rect.top + rect.height / 2;
                container.insertBefore(draggedItem, after ? item.nextSibling : item);
            });
            container.addEventListener('drop', (event) => {
                event.preventDefault();
            });
            container.addEventListener('dragend', () => {
                if (draggedItem == null) {
                    return;
                }
                draggedItem.classList.remove('opacity-50');
                draggedItem.removeAttribute('draggable');
                draggedItem = null;
                onReorder();
            });
        }

        // Keyword selection logic
        const keywordSelectorPattern = 'select[id^="presentation_presentation_keywords_attributes_"][id$="_keyword_id"]';

        function otherKeywordInput(keywordSelector) {
            return document.getElementById(keywordSelector.id.replace(/_keyword_id$/, '_other_keyword'));
        }

        this.element.addEventListener('change', (event) => {
            if (!event.target.matches(keywordSelectorPattern)) {
                return;
            }
            const keywordSelector = event.target;
            const input = otherKeywordInput(keywordSelector);
            if (keywordSelector.length === keywordSelector.selectedIndex + 1) {
                enableElement(input);
                requireElement(input);
                input.focus();
            } else {
                input.value = '';
                unrequireElement(input);
                disableElement(input);
            }
        });
        document.querySelectorAll(keywordSelectorPattern).forEach((keywordSelector) => {
            const input = otherKeywordInput(keywordSelector);
            if (keywordSelector.selectedIndex !== 0 && input.value === '') {
                unrequireElement(input);
                disableElement(input);
            }
        });

        // Add, remove and reorder keywords
        const keywords = document.getElementById('keywords');
        if (keywords != null) {
            function renumberKeywords() {
                renumberItems(keywords, '.presentation-keyword', (item, index) => {
                    item.querySelectorAll('input.keyword-order-num').forEach((element) => {
                        element.value = index;
                        element.setAttribute('value', index);
                    });
                    item.querySelectorAll('.keyword-legend').forEach((element) => {
                        element.textContent = element.textContent.replace(/\d+/, index);
                    });
                });
                const removeButton = document.getElementById('remove-keyword-btn');
                if (keywords.querySelectorAll('.presentation-keyword').length > 1) {
                    appearElement(removeButton);
                } else {
                    hideElement(removeButton);
                }
            }

            document.getElementById('add-keyword-btn').addEventListener('click', function () {
                const allKeywordForms = keywords.querySelectorAll('.presentation-keyword');
                const newForm = allKeywordForms[allKeywordForms.length - 1].cloneNode(true);
                newForm.querySelectorAll('select').forEach((element) => {
                    element.selectedIndex = 0;
                });
                newForm.querySelectorAll('input[type="text"]').forEach((element) => {
                    element.value = '';
                    unrequireElement(element);
                    enableElement(element);
                });
                newForm.removeAttribute('draggable');
                newForm.classList.remove('opacity-50');
                keywords.append(newForm);
                renumberKeywords();
            });
            document.getElementById('remove-keyword-btn').addEventListener('click', function () {
                const allKeywordForms = keywords.querySelectorAll('.presentation-keyword');
                allKeywordForms[allKeywordForms.length - 1].remove();
                renumberKeywords();
            });
            if (keywords.dataset.sortable === 'true') {
                makeSortable(keywords, '.presentation-keyword', renumberKeywords);
            }
            renumberKeywords();
        }

        // Author card logic
        const authorCards = document.getElementById('author-cards');
        let currentAuthorIndex = Number(authorCards.dataset.authorInitialSize);

        function togglePresenter() {
            if (this.checked) {
                this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                    enableElement(element);
                    requireElement(element);
                });
                this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                    element.removeAttribute('hidden');
                });
            } else {
                this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                    disableElement(element);
                    unrequireElement(element);
                    element.value = '';
                });
                this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                    element.setAttribute('hidden', 'hidden');
                });
            }
        }

        document.querySelectorAll('input.author-is-presenter').forEach((element) => {
            element.addEventListener('change', togglePresenter);
        });
        if (currentAuthorIndex === 1) {
            document.getElementById('remove-author-btn').setAttribute('hidden', 'hidden');
        }

        function renumberAuthors() {
            renumberItems(authorCards, '.author-card', (card, index) => {
                card.querySelectorAll('input.author-order-num').forEach((element) => {
                    element.value = index;
                    element.setAttribute('value', index);
                });
                card.querySelectorAll('.author-number').forEach((element) => {
                    element.textContent = element.textContent.replace(/\d+/, index);
                });
            });
        }

        function newAuthorForm(index) {
            const allAuthorForms = document.querySelectorAll('.author-card');
            const newForm = allAuthorForms[allAuthorForms.length - 1].cloneNode(true);
            newForm.querySelectorAll('input').forEach((element) => {
                setIndex(index, element);
                if (element.type === 'checkbox') {
                    element.removeAttribute('checked');
                    element.checked = false;
                    element.value = 1;
                    element.addEventListener('change', togglePresenter);
                } else if (element.type === 'hidden' && element.nextElementSibling?.classList.contains('author-is-presenter')) {
                    // Hidden field rendered by include_hidden for the presenter checkbox
                    element.value = 0;
                } else {
                    element.value = '';
                }
            });
            newForm.querySelectorAll('input.author-order-num').forEach((element) => {
                element.setAttribute('value', index);
                element.value = index;
            });
            newForm.querySelectorAll('input.author-receipt-num').forEach((element) => {
                disableElement(element);
                unrequireElement(element);
            });
            newForm.querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                element.setAttribute('hidden', 'hidden');
            });
            newForm.removeAttribute('draggable');
            newForm.classList.remove('opacity-50');
            newForm.setAttribute('data-index', index);

            return newForm;
        }

        function addAuthor() {
            currentAuthorIndex++;
            const newForm = newAuthorForm(currentAuthorIndex);
            authorCards.append(newForm);
            renumberAuthors();
            document.getElementById('remove-author-btn').removeAttribute('hidden');
            return newForm;
        }

        document.getElementById('add-author-btn').addEventListener('click', addAuthor);
        document.getElementById('remove-author-btn').addEventListener('click', function () {
            const allAuthorForms = document.querySelectorAll('.author-card');
            allAuthorForms[allAuthorForms.length - 1].remove();
            currentAuthorIndex--;
            renumberAuthors();
            if (currentAuthorIndex === 1) {
                document.getElementById('remove-author-btn').setAttribute('hidden', 'hidden');
            }
        });

        // Add the signed-in user as an author.
        // The last card is reused when all of its fields are empty; otherwise a new card is added.
        const addCurrentUserButton = document.getElementById('add-current-user-author-btn');
        if (addCurrentUserButton != null) {
            const currentUser = JSON.parse(addCurrentUserButton.dataset.currentUser);
            addCurrentUserButton.addEventListener('click', function () {
                const allAuthorForms = authorCards.querySelectorAll('.author-card');
                const lastForm = allAuthorForms[allAuthorForms.length - 1];
                const isEmpty = Array.from(lastForm.querySelectorAll('input[type="text"]')).every((element) => element.value === '');
                const card = isEmpty ? lastForm : addAuthor();
                Object.entries(currentUser).forEach(([attribute, value]) => {
                    const input = card.querySelector('input[name$="[' + attribute + ']"]');
                    if (input != null) {
                        input.value = value ?? '';
                    }
                });
                card.scrollIntoView({behavior: 'smooth', block: 'center'});
            });
        }

        if (authorCards.dataset.sortable === 'true') {
            makeSortable(authorCards, '.author-card', renumberAuthors);
        }

        // Reference logic
        const references = document.getElementById('references');
        let currentReferenceIndex = Number(references.dataset.referenceInitialSize);
        if (currentReferenceIndex === 1) {
            document.getElementById('remove-reference-btn').setAttribute('hidden', 'hidden');
        }

        function renumberReferences() {
            renumberItems(references, '.reference', (item, index) => {
                item.querySelectorAll('input.reference-order-num').forEach((element) => {
                    element.value = index;
                    element.setAttribute('value', index);
                });
                item.querySelectorAll('span:not(.sortable-handle)').forEach((element) => {
                    element.innerText = element.innerText.replace(/\d+/, index);
                });
            });
        }

        function newReferenceForm(index) {
            const allReferenceForms = document.querySelectorAll('.reference');
            const newForm = allReferenceForms[allReferenceForms.length - 1].cloneNode(true)
            newForm.querySelectorAll('input').forEach((element) => {
                setIndex(index, element);
                element.value = '';
            });
            newForm.querySelectorAll('span:not(.sortable-handle)').forEach((element) => {
                element.innerText = element.innerText.replace(/\d+/, index);
            });
            newForm.querySelectorAll('input.reference-order-num').forEach((element) => {
                element.setAttribute('value', index);
                element.value = index;
            });
            newForm.removeAttribute('draggable');
            newForm.classList.remove('opacity-50');
            newForm.setAttribute('data-index', index);
            return newForm;
        }

        document.getElementById('add-reference-btn').addEventListener('click', function () {
            currentReferenceIndex++;
            references.append(newReferenceForm(currentReferenceIndex));
            renumberReferences();
            document.getElementById('remove-reference-btn').removeAttribute('hidden');
        });
        document.getElementById('remove-reference-btn').addEventListener('click', function () {
            const allReferenceForms = document.querySelectorAll('.reference');
            allReferenceForms[allReferenceForms.length - 1].remove();
            currentReferenceIndex--;
            renumberReferences();
            if (currentReferenceIndex === 1) {
                document.getElementById('remove-reference-btn').setAttribute('hidden', 'hidden');
            }
        });
        if (references.dataset.sortable === 'true') {
            makeSortable(references, '.reference', renumberReferences);
        }
    }
}